import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";
import { Text } from "./Text";

/**
 * Centered empty / placeholder state — the shared shape for "nothing here yet",
 * 404, route errors, and stage-0 page stubs. Title in the serif voice, optional
 * leading icon, supporting copy, and an action slot.
 */
export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex min-h-full flex-col items-center justify-center gap-4 px-6 py-16 text-center",
        className,
      )}
    >
      {icon ? <div className="text-ink-faint [&_svg]:size-7">{icon}</div> : null}
      <div className="flex max-w-sm flex-col gap-2">
        <Text variant="h4" as="h2">
          {title}
        </Text>
        {description ? (
          <Text variant="subhead" as="p" className="text-[15px]">
            {description}
          </Text>
        ) : null}
      </div>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
